import React, { useEffect, useState } from "react";
import { adminApi } from "../adminApi";

const tableCard = { background: "white", borderRadius: 12, border: "1px solid #E5E7EB", overflow: "hidden" };
const td = { padding: "10px 14px", fontSize: 12.5, color: "#0F1B2D", borderTop: "1px solid #F1F5F9", verticalAlign: "top" };
const th = { padding: "10px 14px", fontSize: 11, color: "#6B7280", textTransform: "uppercase", letterSpacing: 1, textAlign: "left", borderBottom: "1px solid #E5E7EB", fontWeight: 700 };

const ROLE_TONE = { CEO: "#1D4ED8", CFO: "#047857", CMO: "#C2410C", CTO: "#7C3AED" };
const STATUS_TONE = { open: "#1D4ED8", in_progress: "#B45309", completed: "#047857", dismissed: "#6B7280" };

/**
 * Internal-only history of Admin/Expert-injected Command Centre tasks
 * (2026-09, Part 14). Never surfaced to the customer.
 */
export default function ExpertAdminInjectedTasks() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const res = await adminApi.expertInjectedTasks();
      if (res.ok) setRows(res.data.tasks || []);
      setLoading(false);
    })();
  }, []);

  return (
    <div data-testid="expert-admin-injected-tasks">
      <div style={tableCard}>
        <table data-testid="expert-injected-tasks-table" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={th}>Customer</th><th style={th}>Task</th><th style={th}>Task From</th>
              <th style={th}>Priority</th><th style={th}>Due</th><th style={th}>Status</th><th style={th}>Created</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td style={td} colSpan={7}>Loading…</td></tr>}
            {!loading && rows.length === 0 && <tr><td style={td} colSpan={7}>No admin/expert tasks injected yet.</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} data-testid={`injected-task-row-${r.id}`}>
                <td style={td}>
                  <div style={{ fontWeight: 700 }}>{r.company_name || r.customer_name || r.customer_id}</div>
                  <div style={{ color: "#6B7280" }}>{r.customer_name || "—"}</div>
                </td>
                <td style={td}>
                  <div style={{ fontWeight: 600 }}>{r.title}</div>
                  {r.internal_expert_note && <div style={{ color: "#9CA3AF", marginTop: 2 }}>Note: {r.internal_expert_note}</div>}
                </td>
                <td style={td}><span style={{ color: ROLE_TONE[r.executive_role] || "#0F1B2D", fontWeight: 700 }}>{r.executive_role}</span></td>
                <td style={td}>{r.priority}</td>
                <td style={td}>{r.due_date || "—"}</td>
                <td style={td}><span style={{ color: STATUS_TONE[r.status] || "#0F1B2D", fontWeight: 700 }}>{r.status}</span></td>
                <td style={td}>{r.created_at ? new Date(r.created_at).toLocaleDateString("en-IN") : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
